<template>
  <CModal :show.sync="show" :title="$gettext('Set Pica code')" centered>
    <CInput v-model="picaCode" placeholder="Pica Code"/>
    <template #footer>
      <CButton size="sm" @click="show = false" color="secondary" v-translate>Close</CButton>
      <PButton class="btn btn-primary btn-sm"
               :loading="validating"
               @click="onSetPicaCode"
               color="primary"
               translate-context="uploader.to_upload" v-translate>
        Set Pica code
      </PButton>
    </template>
  </CModal>
</template>

<script>

import {mapActions} from "vuex";
import PButton from "@/components/PButton.vue";

export default {
  name: "PicaCodeSelector",
  components: {PButton},
  data() {
    return {
      show: false,
      validating: false,
      picaCode: ''
    }
  },
  computed: {},
  emits: ['update'],
  methods: {
    ...mapActions('uploader', ['validatePicaCode']),
    open(picaCode) {
      this.show = true
      this.picaCode = picaCode || ''
    },
    async onSetPicaCode() {
      this.validating = true
      const isValid = await this.validatePicaCode(this.picaCode)
      this.validating = false

      if (!isValid)
        return this.notifyError(this.$pgettext('uploader', 'Set a valid Pica Code'))

      this.$emit('update', this.picaCode)
      this.show = false
    },
  }
}
</script>

<style scoped>

</style>